module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_sl_slovenian-ddb0cfd809bf281ba59eb6b8bf93b555.svg";